import { defineMessages } from 'react-intl';

export default defineMessages({
    xEndingInx: {
        id: 'ml.common.component.MLSelectPaymontMethod.x ending in x',
        defaultMessage: '{nickname} ending in {last4Digits}'
    },
    titleText: {
        id: 'ml.common.component.MLSelectPaymontMethod.Select from an account on file or click on Add Account below.',
        defaultMessage: "Select from an account on file or click on 'Add Account' below."
    },
    tooltipHeader: {
        id: 'ml.common.component.MLSelectPaymontMethod.Why can\'t I delete the payment method?',
        defaultMessage: 'Why can\'t I delete the payment method?'
    },
    tooltipContent: {
        id: 'ml.common.component.MLSelectPaymontMethod.You must update your policy to add a new payment method before current payment method can be deleted.',
        defaultMessage: 'You must update your policy to add a new payment method before current payment method can be deleted.'
    },
    accounts: {
        id: 'ml.common.component.MLSelectPaymontMethod.Accounts',
        defaultMessage: 'ACCOUNTS'
    },
    actions: {
        id: 'ml.common.component.MLSelectPaymontMethod.Actions',
        defaultMessage: 'ACTIONS'
    },
    delete: {
        id: 'ml.common.component.MLSelectPaymontMethod.Delete',
        defaultMessage: 'Delete'
    },
    edit: {
        id: 'ml.common.component.MLSelectPaymontMethod.Edit',
        defaultMessage: 'Edit'
    },
    addNewAccount: {
        id: 'ml.common.component.MLSelectPaymontMethod.Add account',
        defaultMessage: 'Add account'
    },
    creditCardNotListedOnFile: {
        id: 'ml.common.component.MLSelectPaymontMethod.A credit card is not listed on file.  To add, select ADD ACCOUNT.',
        defaultMessage: 'A credit card is not listed on file.  To add, select ADD ACCOUNT.'
    },
    bankAccountNotListedOnFile: {
        id: 'ml.common.component.MLSelectPaymontMethod.A checking or savings account is not listed on file.  To add, select ADD ACCOUNT.',
        defaultMessage: 'A checking or savings account is not listed on file.  To add, select ADD ACCOUNT.'
    },
    restrictedPaymentMethodError: {
        id: 'ml.gateway.views.account-detail.We are unable to process a credit card payment at this time since the Preferred Payment Method',
        defaultMessage: 'We are unable to process a credit card payment at this time since the Preferred Payment Method was selected and this discount is being applied. Please select a different payment method to use for the payment or update the Preferred Payment Method question in the Payment Frequency section.'
    },
    restrictedPaymentMethodWarning: {
        id: 'ml.gateway.views.account-detail.The Preferred Payment Method was selected and this discount is being applied to one or more of your policies, please select a payment method other than credit card for this one-time payment.',
        defaultMessage: 'The Preferred Payment Method was selected and this discount is being applied to one or more of your policies, please select a payment method other than credit card for this one-time payment.'
    }
});